export const ROOM_FOR_ALLOCATION = 'ROOM_FOR_ALLOCATION'
export const WORKSHIFT_FOR_ALLOCATION = 'WORKSHIFT_FOR_ALLOCATION'
